import type { Breakpoint } from '@mui/material/styles';

export type ResponsiveFontSizes = Partial<
  Record<Breakpoint | 'xxl', string | number>
>;

export interface FontSizeConfig {
  compact: ResponsiveFontSizes;
  normal: ResponsiveFontSizes;
}

// Single source of truth for font size values (in pixels)
export const METRIC_FONT_SIZES: FontSizeConfig = {
  compact: {
    xs: 14,
    sm: 16,
    md: 18,
    lg: 18,
    xl: 18,
    xxl: 18,
  },
  normal: {
    xs: 32, // Mobile: 32px
    sm: 32,
    md: 48, // Desktop: 48px
    lg: 48,
    xl: 48,
    xxl: 48,
  },
} as const;

// Helper function to create font sizes with pxToRem conversion
// This will be called from the hook with theme context
export const getMetricFontSizes = (
  pxToRem: (px: number) => string,
): FontSizeConfig => ({
  compact: {
    xs: pxToRem(METRIC_FONT_SIZES.compact.xs as number),
    sm: pxToRem(METRIC_FONT_SIZES.compact.sm as number),
    md: pxToRem(METRIC_FONT_SIZES.compact.md as number),
    lg: pxToRem(METRIC_FONT_SIZES.compact.lg as number),
    xl: pxToRem(METRIC_FONT_SIZES.compact.xl as number),
    xxl: pxToRem(METRIC_FONT_SIZES.compact.xxl as number),
  },
  normal: {
    xs: pxToRem(METRIC_FONT_SIZES.normal.xs as number),
    sm: pxToRem(METRIC_FONT_SIZES.normal.sm as number),
    md: pxToRem(METRIC_FONT_SIZES.normal.md as number),
    lg: pxToRem(METRIC_FONT_SIZES.normal.lg as number),
    xl: pxToRem(METRIC_FONT_SIZES.normal.xl as number),
    xxl: pxToRem(METRIC_FONT_SIZES.normal.xxl as number),
  },
});
